import { useT } from '../i18n/locale-context';
import { countryConfig } from '../country';

// Optional chaining on purpose: unit tests mock `../country` with partial configs.
const CASTILIAN_TITLES =
  (countryConfig as Partial<typeof countryConfig> | undefined)?.content?.castilianTitles === true;

/**
 * «Título original: …» — the title the platform published, in small type under the Castilian
 * one (`content.castilianTitles`, Spain). The API sends `originalTitle` only for a lot whose
 * shown title is the translation of a Catalan, Valencian, Galician or Basque one; a Spanish
 * lot, and every UZ/KZ lot, carries none and this renders nothing. `tone="onBrand"` is for the
 * lot page's dark header, `light` for the catalogue cards.
 */
export function OriginalTitle({
  title,
  tone = 'light',
  className = '',
}: {
  title?: string | null;
  tone?: 'light' | 'onBrand';
  className?: string;
}) {
  const t = useT();
  if (!CASTILIAN_TITLES || !title) return null;
  return (
    <p
      data-testid="original-title"
      lang="und"
      className={`text-[12px] leading-[1.4] [overflow-wrap:anywhere] ${
        tone === 'onBrand' ? 'text-white/60' : 'text-ink-muted'
      } ${className}`}
    >
      {t('tender.originalTitle', { title })}
    </p>
  );
}
